<fui-page>
    <fui-page-pane>
        <fui-page-header [description]="savedReport ? '\'(' + savedReport.name + ')\'' : descriptionLabel" [hasToggle]="false"
                         [label]="'hey mf'" [title]="title ? '\'' + title + '\'' : titleLabel">
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <fui-formation>
                        <fui-formation-groups>
                            <ng-content></ng-content>
                            <ng-container *ngIf="reportModel.isEntityLocalisable()">
                                <fui-formation-group-template *formationGroup="{title: 'wbo.localisation.formation'}">
                                    <wbo-edit-localisation [forceEnableRestrictions]="true"
                                        [localisable]="reportModel.data.localisableContext"></wbo-edit-localisation>
                                </fui-formation-group-template>
                            </ng-container>
                        </fui-formation-groups>
                    </fui-formation>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
    <fui-page-footer>
        <ng-template #FUIPageFooterButtons>
            <wbo-footer-spinner [label]="'wbo.common.label.generatingReport'"
                                [processing]="running | async"></wbo-footer-spinner>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()" *ngIf="stackedPageContextService"></wbo-cancel-button>
                <wbo-ok-button (click)="performAction()" [title]="'wbo.common.button.report'"></wbo-ok-button>
                <wbo-secondary-button (click)="saveMyReport()"
                                      [title]="'wbo.common.button.saveMyReport'"></wbo-secondary-button>
                <wbo-messaging-footer-button
                    *ngIf="customerSupportMessagingService.isDisplayed() && !stackedPageContextService"></wbo-messaging-footer-button>
            </fui-buttons>
        </ng-template>
    </fui-page-footer>
</fui-page>
